(function () {
  'use strict';

  const trigger = document.getElementById('hm-trigger');
  const drawer = document.getElementById('hm-drawer');
  const overlay = document.getElementById('hm-overlay');
  const panelsContainer = document.getElementById('hm-panels');

  if (!trigger || !drawer || !overlay || !panelsContainer) return;

  const panels = panelsContainer.querySelectorAll('.hm-panel');
  const rootPanel = panelsContainer.querySelector('.hm-panel--root');
  const stack = [];

  function getPanel(name) {
    return panelsContainer.querySelector(`.hm-panel[data-hm-panel="${name}"]`);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
    document.body.classList.add('hm-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('hm-open');
    trigger.setAttribute('aria-expanded', 'false');

    // Reset to root after the slide-out animation finishes
    setTimeout(resetToRoot, 300);
  }

  function resetToRoot() {
    panels.forEach((p) => {
      p.classList.remove('is-active', 'is-stacked-back');
      p.setAttribute('aria-hidden', 'true');
    });
    if (rootPanel) {
      rootPanel.classList.add('is-active');
      rootPanel.setAttribute('aria-hidden', 'false');
    }
    stack.length = 0;
  }

  function openPanel(name) {
    const next = getPanel(name);
    if (!next) return;

    const current = stack.length === 0 ? rootPanel : getPanel(stack[stack.length - 1]);
    if (current) {
      current.classList.remove('is-active');
      current.classList.add('is-stacked-back');
    }
    next.classList.add('is-active');
    next.setAttribute('aria-hidden', 'false');
    stack.push(name);

    // Reset scroll for the freshly opened panel
    next.scrollTop = 0;
  }

  function goBack() {
    if (stack.length === 0) return;
    const currentName = stack.pop();
    const current = getPanel(currentName);
    if (current) {
      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
    }

    const previous = stack.length === 0 ? rootPanel : getPanel(stack[stack.length - 1]);
    if (previous) {
      previous.classList.remove('is-stacked-back');
      previous.classList.add('is-active');
      previous.setAttribute('aria-hidden', 'false');
    }
  }

  // ---- Wire up events ----
  trigger.addEventListener('click', openDrawer);
  overlay.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-hm-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    const backBtn = e.target.closest('[data-hm-back]');
    if (backBtn) {
      e.preventDefault();
      goBack();
      return;
    }

    const helpBtn = e.target.closest('[data-hm-help]');
    if (helpBtn) {
      e.preventDefault();
      // Close the drawer first, then open the global help popup defined in
      // layout/theme.liquid (id="helpPopup", activated via the `active` class).
      closeDrawer();
      const helpPopup = document.getElementById('helpPopup');
      if (helpPopup) {
        helpPopup.classList.add('active');
        const firstField = document.getElementById('helpCategory');
        if (firstField) setTimeout(() => firstField.focus(), 100);
      }
      return;
    }

    const openBtn = e.target.closest('[data-hm-open]');
    if (openBtn) {
      e.preventDefault();
      openPanel(openBtn.getAttribute('data-hm-open'));
    }
  });

  // ---- Close the drawer as soon as the user goes to the search field ----
  // The drawer overlays the page, so any search interaction (header search on
  // desktop, mobile-bottom-search inside the sticky header) should dismiss it:
  // otherwise the predictive-search preview opens behind / next to the panel.
  // Covers focus (tap into the field) and typing (incl. voice input & paste,
  // which fire `input` without a preceding keystroke).
  const SEARCH_FIELDS = 'input[type="search"], .search__input, .mobile-bottom-search__input';

  function closeIfSearch(e) {
    if (!drawer.classList.contains('is-open')) return;
    const field = e.target.closest ? e.target.closest(SEARCH_FIELDS) : null;
    if (!field) return;
    // A search field inside the drawer (none today) must not close it.
    if (drawer.contains(field)) return;
    closeDrawer();
  }

  document.addEventListener('focusin', closeIfSearch);
  document.addEventListener('input', closeIfSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (!drawer.classList.contains('is-open')) return;
    if (stack.length > 0) {
      goBack();
    } else {
      closeDrawer();
    }
  });
})();
